__turbopack_context__.v({
  "modal": "RestaurantSpecialOfferPopup-module-sass-module__78Mr7G__modal",
  "modal-photo": "RestaurantSpecialOfferPopup-module-sass-module__78Mr7G__modal-photo",
  "modal-subtitle": "RestaurantSpecialOfferPopup-module-sass-module__78Mr7G__modal-subtitle",
});
